export class Recon
{
    storeid: string;
    merchantreference: string;       
    reflect: string;
}


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/reconmodel.ts